import React from 'react';
export function TopBar() {
  return <div className="bg-ink px-4 py-2.5 text-center" data-id="element-191" data-mp="2w6n0dv91nxff">
      <p className="text-xs font-semibold uppercase tracking-wide text-white sm:text-sm" data-id="element-192" data-mp="aodtjfo4jac6">
        🔨 Para carpinteros y manitas que buscan{' '}
        <span className="text-action" data-id="element-193" data-mp="fgffjtb3gffe">ingresos extra</span> de forma fácil y segura
      </p>
    </div>;
}